import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const studyEventFormSchemaServices = {
  //Event Form Schema
  addNewEventFormSchema,
  updateEventFormSchema,
  getHeighestVersionEventFormSchemaHistory,
  deleteEventFormSchema,
  softDeleteRestoreEventFormSchema,
  getEventFormSchema,
  getEventBasedonSchema ,
  getStudySchemaFormFieldList,
  getStudyFormBasedonSchemaEvent,
  getEventFormSchemaAuditTrials,
  getAssignedGenderinSchema,
  getFormReportBasedonSchema,
  assignGenderinSchema,
  assignFormFieldinSchema,
};

// Get Study Event Form Schema
async function getEventFormSchema(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEventFormSchema/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEventFormSchema/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Study Event Form Schema
async function addNewEventFormSchema(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewEventFormSchema`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Event Form Schema
async function updateEventFormSchema(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateEventFormSchema`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Event Form Schema
async function softDeleteRestoreEventFormSchema(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreEventFormSchema`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Event Form Schema
async function deleteEventFormSchema(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteEventFormSchema`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Sequence Row Heighest version
async function getHeighestVersionEventFormSchemaHistory(studyId, schemaId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getHeighestVersionEventFormSchemaHistory/${studyId}/${schemaId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Study Event Form Schema Row Audit Trial
async function getEventFormSchemaAuditTrials(studyId, schemaId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEventFormSchemaAuditTrials/${studyId}/${schemaId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Event based on Schema
async function getEventBasedonSchema(studyId, schemaId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEventBasedonSchema/${studyId}/${schemaId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}
// // // Get Study Schema Form Field List
async function getStudySchemaFormFieldList(studyId, schemaId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySchemaFormFieldList/${studyId}/${schemaId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Form Based on Schema and Event
async function getStudyFormBasedonSchemaEvent(studyId, schemaId, eventId, timePointUniqueId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyFormBasedonSchemaEvent/${studyId}/${schemaId}/${eventId}/${timePointUniqueId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Assign Gender in Schema
async function assignGenderinSchema(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignGenderinSchema`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Assign Form Field in Schema
async function assignFormFieldinSchema(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignFormFieldinSchema`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Assigned Gender in Schema
async function getAssignedGenderinSchema(studyId, schemaId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getAssignedGenderinSchema/${studyId}/${schemaId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Form Report Based on Schema
async function getFormReportBasedonSchema(studyId, schemaId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getFormReportBasedonSchema/${studyId}/${schemaId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}